import React, { createContext, useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import AgGridTable from "../utilities/AgGridTable"
import ListPageHeader from "../utilities/ListPageHeader"
import { useNavigate } from "react-router-dom";
import customStyles from "app/shared-components/SelectCustomStyle";
import { Accordion, AccordionDetails, Select as MuiSelect, Button, MenuItem, Tooltip, Typography, Dialog, DialogContent, DialogContentText, IconButton, List, ListItem, ListItemAvatar, Avatar, ListItemText, Divider, Tab, Tabs, Box, AppBar, Toolbar, TextField, Icon, DialogActions, Grid, AccordionSummary, Stack, FormControlLabel, Checkbox } from "@mui/material";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import Select from "react-select";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon/FuseSvgIcon";
import jwtDecode from "jwt-decode";
import DatePickerEditor from "./editor/DatePickerCellEditorComponent";
import GroupRowInnerRenderer from "./GroupRowInnerRenderer";
import AgCharts from "../utilities/AgCharts";
import TextCellEditor from "./editor/TextCellEditor";
import moment from "moment";
import { AgChart } from "ag-charts-community";
import AddOKR from "./AddOKR";
import CheckSubmittedOKR from "./CheckSubmittedOKR";
import TextSearchableCellEditor from "./editor/TextSearchableCellEditor";
const handleSuccessMsg = createContext();
const handleErrorMsg = createContext();
const getGroupingRowData = createContext();
const showEmpChart = createContext();

const OkrPerformance = () => {
    const gridRef = useRef();
    const chartRef = useRef();
    const navigate = useNavigate();
    const [error, setError] = useState("");
    const [snackState, setSnackState] = useState(false);
    const [deleteDisable, setDeleteDisable] = useState(true);
    const [openComments, setOpenComments] = useState(false);
    const [successMsg, setSuccessMsg] = useState();
    const [allsuccessMsg, setAllSuccessMsg] = useState();
    const [rowData, setRowData] = useState([]);
    const [year, setYear] = useState();
    const [quarterly, setQuarterly] = useState();
    const [fullOkrObject, setFullOkrObject] = useState('');
    const [selectedEmp, setSelectedEmp] = useState();
    const [updatedRowData, setUpdatedRowData] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [groupSelectedRows, setGroupSelectedRows] = useState([]);
    const [empGroupSelectedRows, setEmpGroupSelectedRows] = useState([]);
    const [yearList, setYearList] = useState([]);
    const [chartType, setChartType] = useState('column');
    const [addOpen, setAddOpen] = useState(false);
    const [chartOpen, setChartOpen] = useState(false);
    const [groupingRowData, setGroupingRowData] = useState();
    const [selectedEmail, setSelectedEmail] = useState();
    const [checkListValue, setCheckListValue] = useState(false);
    const [tabValue, setTabValue] = useState(0);
    const [expandedGroups, setExpandedGroups] = useState([]);

    const [quarterlyList, setQuarterlyList] = useState([
        { label: "Q1", value: 'Q1' },
        { label: "Q2", value: 'Q2' },
        { label: "Q3", value: 'Q3' },
        { label: "Q4", value: 'Q4' },
        { label: "HY1", value: 'HY1' },
        { label: "HY2", value: 'HY2' },
        { label: "Year", value: 'Year' },
    ]);
    const statusList = [
        { label: 'OK', value: 'OK' },
        { label: 'CRITICAL', value: 'CRITICAL' },
        { label: 'DELAY', value: 'DELAY' },
    ]

    const handleTabChange = (event, value) => {
        setTabValue(value);
    }
    const [empChartOptions, setEmpChartOptions] = useState({
        data: [],
        series: [{
            type: 'column',
            xKey: 'quarter',
            yKey: 'finalWeightedPercentage',
            yName: 'finalWeightedPercentage',
            fillOpacity: 0.5,
        }],
        theme: 'ag-default-dark',
        autoSize: true,
        title: {
            text: `Employee chart`,
        },
        legend: {
            position: 'bottom'
        },
    });
    const token = (localStorage && localStorage.getItem('token')) && jwtDecode(localStorage.getItem('token'));
    const roleMDHR = token?.scope && token?.scope.includes('ROLE_MD') || token?.scope?.includes('ROLE_HR');

    const showPercentage = (props) => {
        return props.value && (props.value + '%')
    }

    const EditRenderer = useCallback((props) => {
        const roleMD = token?.scope && token?.scope.includes('ROLE_MD') || token?.scope?.includes('ROLE_HR');

        return (<span>
            <Tooltip title={"Edit"}>
                <IconButton size="small" sx={{p:0}} className="pl-5" onClick={() => props.handleEditRowDialogOpen(props.data)}
                    disabled={(!props.data.data.grading) ? false : true}
                >
                    <FuseSvgIcon size={18}>
                        heroicons-outline:pencil
                    </FuseSvgIcon>
                </IconButton>
            </Tooltip>

            <Tooltip title={"Add Key result"}>
                <IconButton size="small"  sx={{p:0}} className="pl-5" onClick={() => props.onBtAdd(props.data, 'keyResults')}
                    disabled={(!props.data.data.grading) ? false : true}
                >
                    <FuseSvgIcon size={18}>
                        material-outline:add_box
                    </FuseSvgIcon>
                </IconButton>
            </Tooltip>
        </span>
        );
    }, [fullOkrObject, rowData]);

    const showEditIcon = (props) => {
        const roleMD = token?.scope && (token?.scope.includes('ROLE_MD') || token?.scope?.includes('ROLE_HR'));

        const handleClick = () => {
            const updatedColDef = [...columnDefs]
            let colindexgrading = updatedColDef?.findIndex((column) => column.field === 'grading');
            updatedColDef[colindexgrading].editable = true
            setColumnDefs(updatedColDef)
            if (roleMD) {
                setTimeout(() => {
                    props.api.startEditingCell({
                        rowIndex: props.rowIndex,
                        colKey: props.column.getId(),
                    });
                }, 800);
            }
        };

        return (<span>
            {(roleMD && props.value >= 0) && <Button size="small" sx={{p:0}} style={{ height: '30px' }} onClick={handleClick}>
                <FuseSvgIcon size={18}>
                    heroicons-outline:pencil
                </FuseSvgIcon>
            </Button>}
            <span style={{ paddingLeft: '4px' }}>{props.value && (props.value + '%')}</span>
        </span>)
    }

    const [columnDefs, setColumnDefs] = useState([
        { field: 'Group', editable: false },
        { field: 'empDepartment', rowGroup: true, hide: true },
        { field: 'employeeEmail', rowGroup: true, hide: true },
        { field: 'quarterly', rowGroup: true, hide: true },
        {
            field: 'objectiveValue',
            headerName: 'Objectives',
            enableRowGroup: true,
            rowSpan: function (params) {
                if (params?.data?.objectiveValue !== undefined) {
                    return params?.data?.objlength;
                } else {
                    return 1;
                }
            },
            minWidth: '250',
            cellEditor: TextSearchableCellEditor,
            type: 'editableColumn',
            cellClassRules: {
                'show-cell': "value !== undefined",
            },
            // wrapText: true,
            // autoHeight: true,
            checkboxSelection: params => params?.data?.objectiveValue ? true : false
        },
        {
            field: 'keyResultValue',
            headerName: 'Objectives Key Results',
            type: 'editableColumn',
            cellEditor: TextSearchableCellEditor,
            minWidth: '400',
            // wrapText: true,
            // autoHeight: true,
        },
        {
            field: 'deadLine', enableRowGroup: true,
            cellEditor: DatePickerEditor,
            type: 'editableColumn',
        },
        {
            field: 'weightagePercentage', enableRowGroup: true,
            type: 'editableColumn',
            cellEditor: TextCellEditor,
            valueFormatter: showPercentage
        },
        {
            field: 'grading', enableRowGroup: true,
            type: 'editableColumn',
            cellEditor: TextCellEditor,
            cellRenderer: showEditIcon,
            valueFormatter: showPercentage,
            minWidth: 90,
        },
        {
            field: 'finalWeightedPercentage', enableRowGroup: true,
            type: 'editableColumn',
            cellEditor: TextCellEditor,
            editable: false,
            valueFormatter: showPercentage
        },
        {
            field: "action",
            headerName: "Action",
            editable: false,
            cellRenderer: (data) => (
                <EditRenderer
                    data={data}
                    fullOkr={fullOkrObject}
                    handleEditRowDialogOpen={handleEditRowDialogOpen}
                    onBtAdd={onBtAdd}
                />
            ),
        },
    ]);
    useEffect(() => {
        if (allsuccessMsg) {
            setSuccessMsg(allsuccessMsg);
            setSnackState(true)
            loadOKRData();
        }
    }, [allsuccessMsg])

    const handleEditRowDialogOpen = (event) => {
        onBtStartEditing(event)
    };
    const okrurl = `${process.env.REACT_APP_HR_API_KEY_URL}${oAuthServiceConfig.performance}`;

    const onBtExport = useCallback(() => {
        const params = {
            fileName: 'OkrPerformance.xlsx',
            sheetName: 'OKR Performance'
        }
        gridRef.current.api.exportDataAsExcel(params);
    }, []);

    const onGridReady = useCallback(() => {

    });

    const onSelectionChanged = useCallback((params) => {
        const selectedNodes = params.api.getSelectedNodes();
        if (selectedNodes.length > 0 && selectedNodes[0]?.field === 'quarterly') {
            setGroupSelectedRows(selectedNodes[0]?.allLeafChildren);
            setSelectedRows([]);
            setEmpGroupSelectedRows([]);
            setSelectedEmp('')
        } else if (selectedNodes.length > 0 && selectedNodes[0]?.field === 'employeeEmail') {
            setGroupSelectedRows([])
            setSelectedRows([]);
            setSelectedEmp(selectedNodes[0]?.key);
            setEmpGroupSelectedRows(selectedNodes)
            const empChartData = []
            selectedNodes[0].childrenAfterGroup.map((rowNode) => {
                let finalWeightedPercentage = 0;

                rowNode.allLeafChildren.map((childs) => {
                    finalWeightedPercentage = Number(finalWeightedPercentage) + Number(childs?.data?.finalWeightedPercentage);
                })

                empChartData.push({ quarter: rowNode.key, finalWeightedPercentage: finalWeightedPercentage })
            });

            const clone = { ...empChartOptions };
            clone.data = empChartData;
            setEmpChartOptions(clone);
        } else {
            setGroupSelectedRows([])
            setEmpGroupSelectedRows([])
            setSelectedRows(params.api.getSelectedRows())
            setSelectedEmp('')
        }
    }, [])
    const onRowDoubleClicked = useCallback(() => {
        // navigate('/editOkrPerformance/' + selectedRows[0].id)
    })

    const loadOKRData = useCallback(async () => {
        try {
            // const getokr = await OAuthService.getList(okrurl + '/getOKRByEmail?email=' + empEmail);
            let queryParams = '';
            if (year && quarterly) {
                queryParams = `?year=${year}&quarter=${quarterly}`;
            } else if (quarterly) {
                queryParams = `?quarter=${quarterly}`
            } else if (year) {
                queryParams = `?year=${year}`
            }
            const getokr = await OAuthService.getList(okrurl + `/getAllOkr${queryParams}`);
            const okrData = [];
            getokr?.data && setFullOkrObject(getokr?.data);
            const updatedColDef = [...columnDefs];
            // let colindex = updatedColDef?.findIndex((column) => column.field === 'status');
            // updatedColDef[colindex].cellRenderer = (props) => showCommentHistoryIcon(props, getokr?.data)
            let colindexAction = updatedColDef?.findIndex((column) => column.field === 'action');
            updatedColDef[colindexAction].cellRenderer = (props) => (
                <EditRenderer
                    data={props}
                    fullOkr={getokr?.data}
                    handleEditRowDialogOpen={handleEditRowDialogOpen}
                    onBtAdd={onBtAdd}
                />
            );
            setColumnDefs(updatedColDef);

            getokr?.data && getokr?.data?.map((data) => {
                let objects = {
                    "okrid": data.id,
                    "employeeEmail": data.employeeEmail,
                    "empDepartment": data.empDepartment,
                    'okrStatus': data?.okrStatus,
                    'year': data?.year,
                    'quarterStartDate': data?.quarterStartDate,
                    'dueDate': data?.dueDate,
                    'weekDuration': data?.weekDuration,
                    'startDate': data?.startDate,
                    'endDate': data?.endDate,
                    'quarterly': data.quarterly,
                    'isDraft': data.isDraft,
                    'isCommentAdded': data.isCommentAdded,
                };
                if (data?.objective.length > 0) {
                    data?.objective?.map((obj, key) => {
                        objects = {
                            ...objects,
                            'objId': obj.id,
                            'objlength': Object.keys(obj?.keyResult).length
                        }
                        delete objects.deadLine;
                        delete objects.keyResultValue;
                        delete objects.weightagePercentage;
                        delete objects.grading;
                        delete objects.finalWeightedPercentage;
                        delete objects.objectiveValue;
                        delete objects.resultId;
                        delete objects.status;
                        delete objects.comment;
                        delete objects.weekNo;
                        delete objects.updateNo;
                        delete objects.weekstartDate;
                        delete objects.weekendDate;
                        delete objects.statusId;
                        delete objects.createdAt;
                        delete objects.createdBy;
                        obj?.keyResult?.map((result, index) => {
                            if (index === 0) {
                                objects = {
                                    ...objects,
                                    "deadLine": result.deadLine,
                                    "keyResultValue": result.keyResultValue,
                                    "weightagePercentage": result.weightagePercentage,
                                    "grading": result.grading,
                                    "finalWeightedPercentage": result.finalWeightedPercentage,
                                    "objectiveValue": obj.objectiveValue,
                                    'resultId': result.id
                                }
                            } else {
                                objects = {
                                    ...objects,
                                    "deadLine": result.deadLine,
                                    "keyResultValue": result.keyResultValue,
                                    "weightagePercentage": result.weightagePercentage,
                                    "grading": result.grading,
                                    "finalWeightedPercentage": result.finalWeightedPercentage,
                                    "objectiveValue": undefined,
                                    'resultId': result.id
                                }
                            }
                            delete objects.status;
                            delete objects.weekNo;
                            delete objects.updateNo;
                            delete objects.weekstartDate;
                            delete objects.weekendDate;
                            delete objects.comment;
                            delete objects.statusId;
                            delete objects.createdAt;
                            delete objects.createdBy;
                            result.keyResultStatus && result.keyResultStatus.map((keyStatus, k) => {
                                if (k === (result.keyResultStatus.length - 1)) {
                                    objects = {
                                        ...objects,
                                        "status": keyStatus.status,
                                        "comment": keyStatus.comment,
                                        'statusId': keyStatus.id,
                                        'createdAt': keyStatus.createdAt,
                                        'weekNo': keyStatus.weekNo,
                                        'updateNo': keyStatus.updateNo,
                                        'weekstartDate': keyStatus.startDate,
                                        'weekendDate': keyStatus.endDate,
                                        'createdBy': keyStatus.createdBy
                                    }
                                }
                                return
                            })
                            okrData.push(objects)
                        })
                    })
                } else {
                    okrData.push(objects)
                }
            });
            setRowData(okrData);

            setTimeout(() => {
                if (expandedGroups.length > 0) {
                    expandedGroups.forEach((groupId) => {
                        console.log(groupId);
                        gridRef.current.api.forEachNode((rowNode, index) => {
                            if (rowNode.field === groupId.field && rowNode.key === groupId.key) {

                                rowNode.setExpanded(true);
                            }
                        })
                    });
                }
            }, 50)
        } catch (error) {
            setError(error?.response?.data?.errorMessage || error.message)
        }
    }, [year, quarterly, expandedGroups, gridRef, rowData])

    useEffect(() => {
        loadOKRData();
    }, [year, quarterly]);

    const onRowValueChanged = useCallback((event) => {
        let data = event.data;
        if (data?.weightagePercentage && data?.grading) {
            data.finalWeightedPercentage = Number(Number(Number(data.weightagePercentage * data.grading) / 100)).toFixed(2);
        }
        let includedData = []
        let changedData = updatedRowData.length > 0 && updatedRowData.map((row) => {
            if (row?.okrid === data.okrid) {
                includedData.push(row);
                row = { ...data }
            }
            return row;
        });
        gridRef.current.api.refreshCells();

        if (includedData.length > 0) {
            setUpdatedRowData(changedData);
        } else {
            updatedRowData.push(data);
            setUpdatedRowData(updatedRowData);
        }
    });

    const handleSaveOkr = async () => {
        const saveid = selectedRows[0].okrid;
        const newRowId = selectedRows[0]?.newRowId;
        const oldData = [];
        const updatedData = [];
        const newData = [];
        let calculateFinalPercentage = 0;
        let calculateWeightagePercentage = 0;
        gridRef.current.api.forEachNode((rowNode) => {
            if (rowNode.data) {
                if (rowNode.data.okrid) {
                    if (rowNode.data.okrid === saveid) {
                        updatedData.push(rowNode.data);
                        if (rowNode.data.finalWeightedPercentage) {
                            calculateFinalPercentage = Number(calculateFinalPercentage) + Number(rowNode.data.finalWeightedPercentage);
                        }
                        if (rowNode.data.weightagePercentage) {
                            calculateWeightagePercentage = Number(calculateWeightagePercentage) + Number(rowNode.data.weightagePercentage);
                        }
                        fullOkrObject.map((obj) => {
                            if (obj.id === rowNode.data.okrid) {
                                oldData.push(obj);
                            }
                        })
                    }
                } else {
                    if (rowNode.data.newRowId === newRowId) {
                        if (rowNode.data.finalWeightedPercentage) {
                            calculateFinalPercentage = Number(calculateFinalPercentage) + Number(rowNode.data.finalWeightedPercentage);
                        }
                        if (rowNode.data.weightagePercentage) {
                            calculateWeightagePercentage = Number(calculateWeightagePercentage) + Number(rowNode.data.weightagePercentage);
                        }
                        newData.push(rowNode.data)
                    }
                }
            }
        });

        let nograding = false;
        let addedgrading = false;
        updatedData.map((data) => {
            if (data?.grading > 0) {
                addedgrading = true;
            } else {
                nograding = true
            }
        })

        if (calculateWeightagePercentage > 100) {
            setError('Weightage Percentage can not be greater then 100% ')
        } else if (calculateFinalPercentage > 100) {
            setError('Final Weighted Percentage can not be greater then 100% ')
        } else if (calculateWeightagePercentage < 100) {
            setError('Weightage Percentage should be 100% ')
        } else if (addedgrading && nograding) {
            setError('Please add grading in all key results')
        } else {
            setError('')
            let object = {};
            let objective = [];
            newData.length > 0 && newData.map((data) => {
                object = {
                    ...object,
                    'employeeEmail': data.employeeEmail,
                }
                objective[data.objId] = objective[data.objId] ? { ...objective[data.objId] } : {}
                objective[data.objId]['id'] = data.objId;
                objective[data.objId]['objectiveValue'] = data.objectiveValue && data.objectiveValue;
                objective[data.objId]['keyResult'] = objective[data.objId]['keyResult'] ? [...objective[data.objId]['keyResult']] : [];
                objective[data.objId]['keyResult'][data.resultId] = objective[data.objId]['keyResult'][data.resultId] ? { ...objective[data.objId]['keyResult'][data.resultId] } : {};
                objective[data.objId]['keyResult'][data.resultId]['id'] = data.resultId;
                objective[data.objId]['keyResult'][data.resultId]['keyResultValue'] = data.keyResultValue && data.keyResultValue;
                objective[data.objId]['keyResult'][data.resultId]['deadLine'] = data.deadLine && data.deadLine;
                objective[data.objId]['keyResult'][data.resultId]['grading'] = data.grading && data.grading;
                objective[data.objId]['keyResult'][data.resultId]['weightagePercentage'] = data.weightagePercentage && data.weightagePercentage;
                objective[data.objId]['keyResult'][data.resultId]['finalWeightedPercentage'] = data.finalWeightedPercentage && data.finalWeightedPercentage;
                objective[data.objId]['keyResult'][data.resultId]['keyResultStatus'] = objective[data.objId]['keyResult'][data.resultId]['keyResultStatus'] ? [...objective[data.objId]['keyResult'][data.resultId]['keyResultStatus']] : [];

                if (data.status && data.comment) {
                    objective[data.objId]['keyResult'][data.resultId]['keyResultStatus'][data.statusId] = objective[data.objId]['keyResult'][data.resultId]['keyResultStatus'][data.statusId] ? { ...objective[data.objId]['keyResult'][data.resultId]['keyResultStatus'][data.statusId] } : {};
                    objective[data.objId]['keyResult'][data.resultId]['keyResultStatus'][data.statusId]['id'] = data.statusId;
                    objective[data.objId]['keyResult'][data.resultId]['keyResultStatus'][data.statusId]['status'] = data.status && data.status;
                    objective[data.objId]['keyResult'][data.resultId]['keyResultStatus'][data.statusId]['comment'] = data.comment && data.comment;

                    objective[data.objId]['keyResult'][data.resultId]['keyResultStatus'][data.statusId]['weekNo'] = data.weekNo && data.weekNo,
                        objective[data.objId]['keyResult'][data.resultId]['keyResultStatus'][data.statusId]['startDate'] = data.weekstartDate && data.weekstartDate,
                        objective[data.objId]['keyResult'][data.resultId]['keyResultStatus'][data.statusId]['endDate'] = data.weekendDate && data.weekendDate,
                        objective[data.objId]['keyResult'][data.resultId]['keyResultStatus'][data.statusId]['createdAt'] = data.createdAt ? data.createdAt : moment(new Date()).format('YYYY-MM-DD');
                    objective[data.objId]['keyResult'][data.resultId]['keyResultStatus'][data.statusId]['createdBy'] = data.createdBy ? data.createdBy : token.email;
                }
            });
            updatedData.length > 0 && updatedData.map((data) => {
                object = {
                    ...object,
                    'employeeEmail': data.employeeEmail,
                    'year': data.year,
                    'quarterly': data.quarterly,
                    'id': data.okrid,
                    'okrStatus': data.okrStatus,
                    'startDate': data.startDate,
                    'endDate': data.endDate,
                    'empDepartment': data.empDepartment,
                    'isCommentAdded': data.isCommentAdded,
                    'isDraft': data.isDraft ? data.isDraft : false,
                }
                if (data?.grading && data?.grading > 0) {
                    delete object.isOkrUpdated;
                } else {
                    object = { ...object, isOkrUpdated: true };
                }
                if (data.objId === undefined) {
                    data.objId = 0;
                }
                if (data.resultId === undefined) {
                    data.resultId = 0;
                }

                objective[data.objId] = objective[data.objId] ? { ...objective[data.objId] } : {}
                objective[data.objId]['id'] = data.objId;
                objective[data.objId]['objectiveValue'] = data.objectiveValue ? data.objectiveValue : objective[data.objId]['objectiveValue'];
                objective[data.objId]['keyResult'] = objective[data.objId]['keyResult'] ? [...objective[data.objId]['keyResult']] : [];
                objective[data.objId]['keyResult'][data.resultId] = objective[data.objId]['keyResult'][data.resultId] ? { ...objective[data.objId]['keyResult'][data.resultId] } : {};
                objective[data.objId]['keyResult'][data.resultId]['id'] = data.resultId;
                objective[data.objId]['keyResult'][data.resultId]['keyResultValue'] = data.keyResultValue ? data.keyResultValue : objective[data.objId]['keyResult'][data.resultId]['keyResultValue'];
                objective[data.objId]['keyResult'][data.resultId]['deadLine'] = data.deadLine ? data.deadLine : objective[data.objId]['keyResult'][data.resultId]['deadLine'];
                objective[data.objId]['keyResult'][data.resultId]['grading'] = data.grading ? Number(data.grading) : objective[data.objId]['keyResult'][data.resultId]['grading'];
                objective[data.objId]['keyResult'][data.resultId]['weightagePercentage'] = data.weightagePercentage ? Number(data.weightagePercentage) : objective[data.objId]['keyResult'][data.resultId]['weightagePercentage'];
                objective[data.objId]['keyResult'][data.resultId]['finalWeightedPercentage'] = data.finalWeightedPercentage ? Number(data.finalWeightedPercentage) : objective[data.objId]['keyResult'][data.resultId]['finalWeightedPercentage'];
                objective[data.objId]['keyResult'][data.resultId]['keyResultStatus'] = objective[data.objId]['keyResult'][data.resultId]['keyResultStatus'] ? [...objective[data.objId]['keyResult'][data.resultId]['keyResultStatus']] : [];
                if (data.statusId > 0) {
                    for (let i = 0; i < data.statusId; i++) {
                        objective[data.objId]['keyResult'][data.resultId]['keyResultStatus'][i] = oldData[0].objective[data.objId]['keyResult'][data.resultId]['keyResultStatus'][i] ? { ...oldData[0].objective[data.objId]['keyResult'][data.resultId]['keyResultStatus'][i] } : {}
                    }
                }
                if (data.status && data.comment) {
                    if (data.statusId === undefined) {
                        data.statusId = 0;
                    }
                    objective[data.objId]['keyResult'][data.resultId]['keyResultStatus'][data.statusId] = objective[data.objId]['keyResult'][data.resultId]['keyResultStatus'][data.statusId] ? { ...objective[data.objId]['keyResult'][data.resultId]['keyResultStatus'][data.statusId] } : {};
                    objective[data.objId]['keyResult'][data.resultId]['keyResultStatus'][data.statusId]['id'] = data.statusId;
                    objective[data.objId]['keyResult'][data.resultId]['keyResultStatus'][data.statusId]['status'] = data.status && data.status;
                    objective[data.objId]['keyResult'][data.resultId]['keyResultStatus'][data.statusId]['comment'] = data.comment && data.comment;
                    objective[data.objId]['keyResult'][data.resultId]['keyResultStatus'][data.statusId]['weekNo'] = data.weekNo && data.weekNo,
                        objective[data.objId]['keyResult'][data.resultId]['keyResultStatus'][data.statusId]['startDate'] = data.weekstartDate && data.weekstartDate,
                        objective[data.objId]['keyResult'][data.resultId]['keyResultStatus'][data.statusId]['endDate'] = data.weekendDate && data.weekendDate,
                        objective[data.objId]['keyResult'][data.resultId]['keyResultStatus'][data.statusId]['createdAt'] = data.createdAt ? data.createdAt : moment(new Date()).format('YYYY-MM-DD');
                    objective[data.objId]['keyResult'][data.resultId]['keyResultStatus'][data.statusId]['createdBy'] = data.createdBy ? data.createdBy : token.email;
                }
            });
            object = { ...object, 'objective': objective }
            try {
                if (selectedRows[0].okrid) {
                    await OAuthService.putData(okrurl + '/updateOkr', object);
                    setSuccessMsg("Objective updated Successfully");
                    setSnackState(true);
                    loadOKRData()
                } else {
                    await OAuthService.addData(okrurl + '/okrSubmit', object)
                    setSuccessMsg("Objective added Successfully");
                    setSnackState(true)
                    loadOKRData()
                }

            } catch (error) {
                setError(error?.response?.data?.errorMessage || error.message)
            }
        }
    }

    useEffect(() => {

        const cyear = (new Date()).getFullYear();
        let years = Array.from(new Array(20), (val, index) => { return { label: cyear - index, value: cyear - index } });
        setYear(cyear)
        setYearList(years);
    }, [])

    const onQuarterlyChange = (data,action) => {
        setQuarterly(action.action === "clear"?"":data.value);
        loadOKRData()
    }
    const onYearChange = (data,action) => {
        setYear(action.action === "clear"?"":data.value);
        loadOKRData()
    }

    const hederDropdowns = useCallback(() => {
        const sameData = [];
        if (selectedRows.length > 0) {
            updatedRowData.map((row) => {
                if (row.okrid === selectedRows[0].okrid) {
                    sameData.push(row);
                }
                return row;
            })
        }
        const roleMD = token?.scope && token?.scope.includes('ROLE_MD') || token?.scope?.includes('ROLE_HR');
        return (
            <>
                <label className="pt-12">Year</label>
                <Select
                    name="year"
                    value={(yearList && year) && yearList.filter(obj => year === obj.value)}
                    onChange={onYearChange}
                    className="w-[110px]"
                    options={yearList}
                    styles={customStyles('', '', '0px')}
                    isClearable
                />
                <label className="pt-12">Quarter</label>
                <Select
                    name="quarterly"
                    value={(quarterlyList && quarterly) && quarterlyList.filter(obj => quarterly === obj.value)}
                    onChange={onQuarterlyChange}
                    className="w-[95px] p-1"
                    options={quarterlyList}
                    styles={customStyles('', '', '0px')}
                    isClearable
                />
                {(selectedRows.length > 0 && sameData.length > 0) && <Tooltip title="Save OKR">
                    <Button
                        variant="contained"
                        color="warning"
                        onClick={handleSaveOkr}
                    >
                        <FuseSvgIcon>heroicons-solid:document</FuseSvgIcon>
                    </Button>
                </Tooltip>}
            </>
        )
    }, [updatedRowData, groupSelectedRows, selectedRows, yearList, year, quarterly, quarterlyList]);

    function getQuarter(date = new Date()) {
        return Math.floor(date.getMonth() / 3 + 1);
    }

    const onBtAdd = useCallback((event, type) => {
        let objId = 0;
        let newRowId = 0;
        let status = 0;
        const updatedColDef = [...columnDefs]
        let resultId = 0;
        let empQuarter = []
        let currentIndex = event.node.rowIndex;
        event.api.getRenderedNodes().map((node, index) => {
            let rowNode = node?.data;
            if (rowNode) {
                if (event.node.allLeafChildren) {
                    if (rowNode?.employeeEmail === event?.node?.allLeafChildren[0].data?.employeeEmail) {
                        empQuarter.push(rowNode.quarterly);
                        if (event?.node?.allLeafChildren[0].data?.newRowId) {
                            newRowId = event?.node?.allLeafChildren[0].data?.newRowId;
                        }
                    }
                    if (rowNode && rowNode.employeeEmail === event?.node?.allLeafChildren[0].data?.employeeEmail &&
                        rowNode.quarterly === event?.node?.allLeafChildren[0].data?.quarterly) {
                        if (type === 'keyResults' && rowNode.objId === event?.node?.allLeafChildren[0].data?.objId && rowNode.resultId >= resultId) {
                            currentIndex = index;
                            resultId = rowNode.resultId;
                            status = 1;
                        } else if (type !== 'keyResults' && rowNode.objId >= objId) {
                            currentIndex = index;
                            objId = rowNode.objId
                        }
                    }
                } else {
                    if (rowNode.employeeEmail === event?.node?.data?.employeeEmail && rowNode.quarterly === event?.node?.data?.quarterly) {
                        if (type === 'keyResults' && rowNode.objId === event?.node?.data?.objId && rowNode.resultId >= resultId) {
                            resultId = rowNode.resultId;
                            currentIndex = index;
                            status = 1;
                        } else if (type !== 'keyResults' && rowNode.objId >= objId) {
                            objId = rowNode.objId;
                            currentIndex = index;
                        }
                    }
                }
                return rowNode;
            }
        });
        objId = Number(objId) + 1;
        resultId = (status > 0) ? Number(resultId) + 1 : resultId;

        let colindex = updatedColDef?.findIndex((column) => column.field === 'objectiveValue');
        updatedColDef[colindex].editable = true
        let colindexkey = updatedColDef?.findIndex((column) => column.field === 'keyResultValue');
        updatedColDef[colindexkey].editable = true
        let colindexdeadLine = updatedColDef?.findIndex((column) => column.field === 'deadLine');
        updatedColDef[colindexdeadLine].editable = true
        let colindexweightagePercentage = updatedColDef?.findIndex((column) => column.field === 'weightagePercentage');
        updatedColDef[colindexweightagePercentage].editable = true
        updatedColDef[colindexdeadLine].editable = true
        let colindexgrading = updatedColDef?.findIndex((column) => column.field === 'grading');
        updatedColDef[colindexgrading].editable = false

        let newRow = {
            "objectiveValue": "",
            "deadLine": null,
            "keyResultValue": "",
            "weightagePercentage": 0,
            "grading": 0,
            "finalWeightedPercentage": 0,
            'objId': 0,
            'resultId': 0,
        }
        if (event.node.field === 'quarterly') {
            newRow = {
                "okrid": event.node.allLeafChildren[0].data.okrid ? event.node.allLeafChildren[0].data.okrid : event.node.allLeafChildren[0].data.newRowId,
                "employeeEmail": event.node.allLeafChildren[0].data.employeeEmail,
                "quarterly": event.node.allLeafChildren[0].data.quarterly,
                "year": event.node.allLeafChildren[0].data.year,
                "endDate": event.node.allLeafChildren[0].data.endDate,
                "startDate": event.node.allLeafChildren[0].data.startDate,
                "empDepartment": event.node.allLeafChildren[0].data.empDepartment,
                "okrStatus": event.node.allLeafChildren[0].data.okrStatus,
                "isCommentAdded": false,
                "isDraft": false,
                'objId': objId,
                "objectiveValue": "",
                "deadLine": null,
                "keyResultValue": "",
                "weightagePercentage": 0,
                "grading": 0,
                "finalWeightedPercentage": 0,
                "status": "",
                "comment": "",
                'resultId': 0,
                'statusId': 0,
            }
        }
        if (event.node.field !== 'quarterly' && type === 'objective') {

            newRow = {
                "okrid": event.node.data.okrid ? event.node.data.okrid : event.node.data.newRowId,
                "employeeEmail": event.node.data.employeeEmail,
                "quarterly": event.node.data.quarterly,
                "year": event.node.data.year,
                "isCommentAdded": false,
                "isDraft": false,
                "endDate": event.node.data.endDate,
                "startDate": event.node.data.startDate,
                "empDepartment": event.node.data.empDepartment,
                "okrStatus": event.node.data.okrStatus,
                "objectiveValue": "",
                "deadLine": null,
                "keyResultValue": "",
                "weightagePercentage": 0,
                "grading": 0,
                "finalWeightedPercentage": 0,
                "status": "",
                'objId': objId,
                'resultId': 0,
                'statusId': 0,
                "comment": ""
            }
        } else if (type === 'keyResults') {
            let colindex = updatedColDef?.findIndex((column) => column.field === 'objectiveValue');
            updatedColDef[colindex].editable = false
            newRow = {
                "okrid": event.node.data.okrid ? event.node.data.okrid : event.node.data.newRowId,
                "employeeEmail": event.node.data.employeeEmail,
                "isCommentAdded": false,
                "isDraft": false,
                "quarterly": event.node.data.quarterly,
                "year": event.node.data.year,
                "endDate": event.node.data.endDate,
                "startDate": event.node.data.startDate,
                "empDepartment": event.node.data.empDepartment,
                'objId': event.node.data.objId,
                'resultId': resultId,
                'statusId': 0,
                "objectiveValue": '',
                "deadLine": null,
                "keyResultValue": "",
                "weightagePercentage": 0,
                "grading": 0,
                "finalWeightedPercentage": 0,
            }
        }
        setColumnDefs(updatedColDef);
        let index = rowData && rowData?.findIndex((row) => row.okrid === event?.node?.data?.okrid);
        let nextIndex = Number(currentIndex) + 1;
        rowData && rowData?.splice(nextIndex, 0, newRow);
        const correctRowIndex = gridRef.current.api.applyTransaction({ add: [newRow], addIndex: nextIndex });
        gridRef.current.api.refreshCells();
        setTimeout(() => {
            gridRef.current.api.setFocusedCell(correctRowIndex.add[0].rowIndex, 'objectiveValue')
            gridRef.current.api.startEditingCell({
                rowIndex: correctRowIndex.add[0].rowIndex,
                colKey: 'objectiveValue',
            });
        }, 800);

    }, [rowData]);

    const onBtStartEditing = useCallback((event) => {

        const updatedColDef = [...columnDefs]
        let colindex = updatedColDef?.findIndex((column) => column.field === 'objectiveValue');
        updatedColDef[colindex].editable = true
        let colindexkey = updatedColDef?.findIndex((column) => column.field === 'keyResultValue');
        updatedColDef[colindexkey].editable = true
        let colindexdeadLine = updatedColDef?.findIndex((column) => column.field === 'deadLine');
        updatedColDef[colindexdeadLine].editable = true
        let colindexweightagePercentage = updatedColDef?.findIndex((column) => column.field === 'weightagePercentage');
        updatedColDef[colindexweightagePercentage].editable = true
        let colindexgrading = updatedColDef?.findIndex((column) => column.field === 'grading');
        updatedColDef[colindexgrading].editable = false
        setColumnDefs(updatedColDef)
        const data = event?.node?.data;
        const index = event?.node?.rowIndex;
        setTimeout(() => {
            gridRef.current.api.setFocusedCell(index, 'objectiveValue')
            gridRef.current.api.startEditingCell({
                rowIndex: index,
                colKey: 'objectiveValue',
            });
        }, 800);

    }, [rowData]);

    const onBtDeleteRow = useCallback((event) => {
        const selectedRow = event.node.allLeafChildren && event.node.allLeafChildren;
        rowData?.splice(event.node.rowIndex, 1);
        selectedRow.map(async (row) => {
            if (row.data.okrid) {
                try {
                    const deleted = await OAuthService.getList(okrurl + '/deleteOkrById?id=' + row.data.okrid);
                    if (deleted?.data) {
                        setSuccessMsg(deleted?.data);
                        setSnackState(true)
                        loadOKRData();
                    }
                    setError('')
                } catch (error) {
                    setError(error?.response?.data?.errorMessage || error.message)
                }
            }
        })
    }, [gridRef, rowData])

    const getContextMenuItems = useCallback((event) => {
        const result = [
            {
                name: "Add OKR",
                icon: '<span><i class="material-icons style="font-size: 18px">add</i></span>',
                disabled: empGroupSelectedRows.length > 0 ? false : true,
                action: () => {
                    setAddOpen(true)
                    setSelectedEmail(empGroupSelectedRows[0].allLeafChildren[0].data.employeeEmail);
                },
            },
            {
                name: "Add OKR objective",
                icon: '<span><i class="material-icons" style="font-size: 18px">add</i></span>',
                disabled: groupSelectedRows.length > 0 ? false : true,
                action: () => {
                    onBtAdd(event, 'objective');
                },
            },
            {
                name: "Add OKR key results",
                icon: '<span><i class="material-icons" style="font-size: 18px">add</i></span>',
                disabled: selectedRows.length > 0 ? false : true,
                action: () => {
                    onBtAdd(event, 'keyResults');
                },
            },
            {
                name: "Edit OKR",
                icon: '<span><i class="material-icons" style="font-size: 18px">edit</i></span>',
                disabled: selectedRows.length > 0 ? false : true,
                action: () => {
                    onBtStartEditing(event);
                },
            },
            'separator',
            'export',
            'chartRange'
        ];
        const roleMD = token?.scope && token?.scope.includes('ROLE_MD') || token?.scope?.includes('ROLE_HR');
        if (roleMD) {
            result.unshift(

                {
                    name: "Delete OKR",
                    icon: '<span><i class="material-icons" style="font-size: 18px">delete</i></span>',
                    disabled: empGroupSelectedRows.length > 0 || groupSelectedRows.length > 0 ? false : true,
                    action: () => {
                        onBtDeleteRow(event);
                    },
                })
        } else {
        }
        return result;
    }, [selectedRows, groupSelectedRows, empGroupSelectedRows]);

    const isCellEditable = useCallback((params) => {
        if (params.data.grading) {
            return false;
        } else {
            if (params.column.colId === 'grading') {
                return false;
            } else {
                return true;
            }
        }
    }, []);

    const isCellNotEditable = useCallback((params) => {
        const roleMD = token?.scope && token?.scope.includes('ROLE_MD') || token?.scope?.includes('ROLE_HR');
        if (roleMD) {
            return false
        } else {
            return true;
        }
    }, []);

    const columnTypes = useMemo(() => {
        return {
            editableColumn: {
                editable: (params) => {
                    return isCellEditable(params);
                },
            },
            mdHrEditableColumn: {
                editable: (params) => {
                    return isCellNotEditable(params);
                },
            }
        };
    }, []);

    const groupRowRendererParams = useMemo(() => {
        return {
            innerRenderer: GroupRowInnerRenderer,
            checkbox: true,
            groupUseEntireRow: true,
            suppressCount: true
        }
    });

    const handleChartTypeChange = (event) => {
        setChartType(event.target.value)
        if (event.target.value === 'pie') {
            setEmpChartOptions((prevOptions) => ({
                ...prevOptions,
                series: [{
                    type: event.target.value,
                    labelKey: 'quarter',
                    angleKey: 'finalWeightedPercentage',
                    fillOpacity: 0.5,
                }],
            }))
        } else {
            setEmpChartOptions((prevOptions) => ({
                ...prevOptions,
                series: [{
                    type: event.target.value,
                    xKey: 'quarter',
                    yKey: 'finalWeightedPercentage',
                    yName: 'finalWeightedPercentage',
                    // fillOpacity: 0.5,
                }],
            }))
        }
    }

    const downloadChart = useCallback(() => {
        chartRef?.current?.chart && AgChart.download(chartRef?.current?.chart);
    }, []);


    useEffect(() => {
        loadOKRData()
    }, [tabValue]);


    useEffect(() => {
        if (groupingRowData) {
            if (groupingRowData.type === 'deleteOkr') {
                onBtDeleteRow(groupingRowData.event)
            } else if (groupingRowData.type === 'addCategory') {
                onBtAdd(groupingRowData.event, 'objective')
            }
        }
    }, [groupingRowData]);

    const onRowGroupOpened = (params) => {
        const groups = [...expandedGroups]
        if (params.node.expanded) {

            groups.push({ key: params.node.key, field: params.node.field })
        } else {
            let index = groups.findIndex((grp) => grp.key === params.node.key && grp.field === params.node.field);
            if (index > -1) {
                groups.splice(index, 1);
            }
        }
        setExpandedGroups(groups)
    };

    const getRowStyle = (params) => {
        if (params.node.field === 'quarterly' && params.node.group) {
            if (params?.node?.allLeafChildren && params?.node?.allLeafChildren.length > 0) {
                const diff = new Date(params?.node?.allLeafChildren[0].data?.dueDate) - new Date();
                const diffDays = Math.ceil(diff / (1000 * 60 * 60 * 24));
                if (params.node.allLeafChildren[0].data.isCommentAdded === true && params.node.allLeafChildren[0].data?.objectiveValue) {
                    return { backgroundColor: '#135a02' };
                } else if (params.node.allLeafChildren[0].data.isCommentAdded === false && params.node.allLeafChildren[0].data?.objectiveValue) {
                    if (diffDays <= 3) {
                        return { backgroundColor: '#7f0301' };
                    } else {
                        return { backgroundColor: '#135a02' };
                    }
                }
            }
        }
    }

    const handleListChangeSelected = (value) => {
        setCheckListValue(value)
    }

    return (
        <>
            <getGroupingRowData.Provider value={[groupingRowData, setGroupingRowData]}>
                <showEmpChart.Provider value={[chartOpen, setChartOpen]}>
                    <handleSuccessMsg.Provider value={[allsuccessMsg, setAllSuccessMsg]}>
                    <handleErrorMsg.Provider value={[error, setError]}>
                        <ListPageHeader
                            componentName="OkrPerformance"
                            onBtExport={onBtExport}
                            // handlePurge={handlePurge}
                            // addPageLink={"/addOkrPerformance"}
                            pageName="OKR Performance Management"
                            error={error}
                            successMsg={successMsg}
                            gridRef={gridRef}
                            deleteDisable={deleteDisable}
                            headerInputFields={hederDropdowns()}
                            snackState={snackState}
                            pageSize={roleMDHR && 50}
                        />
                       <Tabs
                            value={tabValue}
                            onChange={handleTabChange}
                            indicatorColor="secondary"
                            textColor="inherit"
                            variant="scrollable"
                            scrollButtons="auto"
                            classes={{ root: 'w-full border-b-1' }}
                        >
                            {!checkListValue && (
                                <Tab 
                                    label="OKR" 
                                    sx={{ color: 'text.secondary', '&.Mui-selected': { color: 'text.primary' } }}
                                />
                            )}
                            {(roleMDHR && !checkListValue) && (
                                <Tab 
                                    label="Assign OKR" 
                                    sx={{ color: 'text.secondary', '&.Mui-selected': { color: 'text.primary' } }}
                                />
                            )}
                            {roleMDHR && (
                                <FormControlLabel
                                    className="flex-row-reverse w-full"
                                    control={
                                        <Checkbox
                                            onChange={(e) => handleListChangeSelected(e.target.checked)}
                                            value={checkListValue}
                                            sx={{ '& .MuiSvgIcon-root': { fontSize: 16 }, '.MuiFormControlLabel-label': { fontSize: 12 } }}
                                        />
                                    }
                                    label="Show submitted/Not submitted list" 
                                />
                            )}
                        </Tabs>
                        {checkListValue && <CheckSubmittedOKR />}

                        <div className={tabValue !== 0 ? 'hidden' : "h-full"}>
                            {!checkListValue && <AgGridTable
                                rowData={rowData}
                                columnDefs={columnDefs}
                                onGridReady={onGridReady}
                                editType={'fullRow'}
                                columnTypes={columnTypes}
                                onSelectionChanged={onSelectionChanged}
                                // getContextMenuItems={getContextMenuItems}
                                groupAllowUnbalanced={true}
                                onRowDoubleClicked={onRowDoubleClicked}
                                onRowValueChanged={onRowValueChanged}
                                gridRef={gridRef}
                                wrapHeaderText={true}
                                autoHeaderHeight={true}
                                tableClassName={'okrPermanceManagementGrid'}
                                groupDisplayType={'groupRows'}
                                groupRowRendererParams={groupRowRendererParams}
                                rowSelection={'single'}
                                getRowStyle={getRowStyle}
                                suppressRowTransform={true}
                                hideCheckbox={true}
                                onRowGroupOpened={onRowGroupOpened}
                            />}
                        </div>
                        <div className={tabValue !== 1 ? 'hidden' : ''}><AddOKR /></div>
                        <Dialog
                            open={chartOpen}
                            fullWidth
                            maxWidth={'md'}
                        >
                            <AppBar position="static">
                                <Toolbar className="flex w-full justify-between">
                                    <Typography variant="subtitle1" color="inherit">
                                        Employee Chart
                                    </Typography>
                                    <IconButton onClick={() => setChartOpen(false)}>
                                        <Icon>close</Icon>
                                    </IconButton>
                                </Toolbar>
                            </AppBar>
                            <DialogContent>
                                {selectedEmp && <>
                                    <div className="flex flex-col sm:flex-row space-y-16 sm:space-y-0 flex-1 w-full items-center justify-between pt-10">
                                        <div className="flex flex-row items-center justify-between space-x-16" >
                                            <Typography>Chart Type: </Typography>
                                            <MuiSelect onChange={handleChartTypeChange} value={chartType}>
                                                <MenuItem value='pie'>Pie</MenuItem>
                                                <MenuItem value='bar'>Bar</MenuItem>
                                                <MenuItem value='line'>Line</MenuItem>
                                                <MenuItem value='area'>Area</MenuItem>
                                                {/* <MenuItem value='scatter'>Scatter</MenuItem>
                                    <MenuItem value='histogram'>Histogram</MenuItem> */}
                                                <MenuItem value='column'>Column</MenuItem>
                                            </MuiSelect>
                                        </div>
                                        <Button
                                            variant="contained"
                                            color="warning"
                                            className="mb-10"
                                            onClick={downloadChart}
                                        >
                                            <FuseSvgIcon>heroicons-solid:download</FuseSvgIcon>
                                        </Button>
                                    </div>
                                    <div className="h-[200px]">
                                        <AgCharts
                                            chartRef={chartRef}
                                            options={empChartOptions}
                                        />
                                    </div>
                                </>}
                            </DialogContent>
                        </Dialog>

                    </handleErrorMsg.Provider>
                    </handleSuccessMsg.Provider>
                </showEmpChart.Provider>
            </getGroupingRowData.Provider>
        </>
    )
}


export default OkrPerformance;
export { handleSuccessMsg, getGroupingRowData, showEmpChart, handleErrorMsg };